import styled from "@emotion/styled";
import { useOneLinkUrl } from "contexts/OneLinkScript";
import QRCodeLayout from "pazChargeComponents/general/QRCode";
import ScrollUpButton, { useScrollMinMax } from "pazChargeComponents/general/ScrollUpButton";
import { Desktop } from "ui";

const StyledContainerPositioned = styled.div<{ hide: boolean }>`

position: fixed;
bottom: 50px;
right: 0px;
z-index: 1000;
display: flex;
align-items: flex-end;
  ${(props) => props.theme.breakpoints.up("md")} {
 bottom: 100px;
right: 70px;
  }
  ${(props) => props.theme.breakpoints.up("md")} {
 bottom: 150px;
  }
 ${(props) => props.hide && "display: none;"}
`
const StyledButtonWrapper = styled.div`
    padding-bottom: 20px;
`

interface QRCodeChargeProps {
    showScrollIcon?: boolean
    showQRCode?: boolean
    text?: string
    minYOffset?: number,
    showInDefault?: boolean
}


function QRCodeCharge({ showScrollIcon, showQRCode = true, text, minYOffset = 0, showInDefault = true }: QRCodeChargeProps) {
    const [isOffsetPassed] = useScrollMinMax(minYOffset, 0, showInDefault)
    const { oneLinkUrl } = useOneLinkUrl()

    if (!isOffsetPassed) {
        return null
    }

    return (
        <>
            <StyledContainerPositioned hide={!isOffsetPassed}>
                {showScrollIcon &&
                    <StyledButtonWrapper>
                        <ScrollUpButton />
                    </StyledButtonWrapper>
                }
                {showQRCode &&
                    <Desktop>
                        <QRCodeLayout text={text} url={oneLinkUrl} />
                    </Desktop>
                }
            </StyledContainerPositioned>
        </>
    );
}
export default QRCodeCharge
